/** Property name of userTagMaxLength field */
export const USER_TAG_MAX_LENGTH_PROPERTY_NAME = 'userTagMaxLength';
/** The default maximum length constraint for a user tag. */
const USER_TAG_MAX_LENGTH_CONFIG = 64;
/** Configuration manager that holds all configs and constraints at the Pod level. */
export class ConfigurationManager {
    constructor() {
        // Empty constructor
    }
    /**
     * Returns the max length constraint of a user tag.
     * If error happens when retrieving the config or config value is null, logs the error and fallback to default constraint.
     * @returns The max length size of a user tag.
     */
    getUserTagMaxLength() {
        // Disable the use of config node as it introduces transit labelId consensus errors when rolling out to larger release group.
        // Use the hardcoded limit for now until a better way of reading from backend response or ECS config is available.
        return USER_TAG_MAX_LENGTH_CONFIG;
    }
}
//# sourceMappingURL=configurationManager.js.map